'use strict';

var version = "0.0.0";

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

// Default options for the plugin.
var defaults = {};

window._qualityButton;
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-hls-quality');
    player.hlsQuality = new hlsQualityPlugin(player, options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function hlsQuality
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var hlsQuality = function hlsQuality(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};
var self$1 = void 0;

var hlsQualityPlugin = function () {
    function hlsQualityPlugin(player, options) {
        classCallCheck(this, hlsQualityPlugin);

        this.player = player;
        this.options = options;
        this.levelsAll = [];
        self$1 = this;
        // If there is quality levels plugin and the HLS tech exists
        // then continue.
        if (this.player.qualityLevels && this.getHls()) {
            this.eventHls();
            this.createQualityButton();
            this.getHls().masterPlaylistController_.mainSegmentLoader_.on('earlyabort', function (e) {
                console.log(e);
                self$1.setQuality(480);
            });
        }

        this.player.on("changequalityhls", function (e, data) {
            self$1.setQuality(data.height);
        });
    }

    hlsQualityPlugin.prototype.getHls = function getHls() {
        return this.player.tech({ IWillNotUseThisInPlugins: true }).hls;
    };

    hlsQualityPlugin.prototype.bindPlayerEvents = function bindPlayerEvents() {
        this.player.qualityLevels().on('addqualitylevel', this.onAddQualityLevel.bind(this));
    };

    hlsQualityPlugin.prototype.eventHls = function eventHls() {
        var _self = this;
        var uepPlayer = this.player;

        this.player.on('fullscreenchange', function () {
            var mostBitrait = Math.max.apply(Math, self$1.levelsAll);
            var item_hls = document.querySelectorAll(".vjs-QualitySelector li");

            if (uepPlayer.isFullscreen()) {
                _self.currentBitraite = document.getElementsByClassName("vjs-tech")[0].videoHeight;

                for (var i = 0; i < window._qualityButton.items.length; ++i) {

                    if (window._qualityButton.items[i].options_.value !== mostBitrait) {
                        window._qualityButton.items[i].selected(false);
                        item_hls[i + 1].classList.remove('vjs-selected');
                    } else {
                        item_hls[i + 1].classList.add('vjs-selected');
                        document.querySelector('.vjs-settings-sub-menu-value.quality-menu-value').innerText = window._qualityButton.items[i].options_.value + "p";
                        window._qualityButton.items[i].selected(true);
                    }
                }

                _self.setQuality(mostBitrait);
            } else {
                for (var _i = 0; _i < window._qualityButton.items.length; ++_i) {
                    if (window._qualityButton.items[_i].options_.value != _self.currentBitraite) {
                        window._qualityButton.items[_i].selected(false);
                        item_hls[_i + 1].classList.remove('vjs-selected');
                    } else {
                        item_hls[_i + 1].classList.add('vjs-selected');
                        document.querySelector('.vjs-settings-sub-menu-value.quality-menu-value').innerText = window._qualityButton.items[_i].options_.value + "p";
                        window._qualityButton.items[_i].selected(true);
                    }
                }
                _self.setQuality(_self.currentBitraite);
            }
        });
        function handleResolutionChange(event) {
            var videos = document.getElementsByClassName("vjs-tech");
            if (videos[0] !== undefined) {
                event.target.dataset.width = videos[0].videoWidth;
                event.target.dataset.height = videos[0].videoHeight;
            }
        }

        if (_self.options.defaultBitrate && _self.options.defaultBitrate !== null && _self.options.defaultBitrate !== undefined && _self.options.defaultBitrate !== -1) {
            _self.setQuality(_self.options.defaultBitrate);
        }

        var video = document.querySelector("video");
        this.player.on("loadedmetadata", function (event) {
            var videos = document.getElementsByClassName("vjs-tech");
            var empQuality = self$1.getCookie('emp-quality');
            if (empQuality && self$1.levelsAll.includes(empQuality)) {
                _self.setQuality(empQuality);
            } else if (_self.options.defaultBitrate && _self.options.defaultBitrate !== null && _self.options.defaultBitrate !== undefined && _self.options.defaultBitrate !== -1) {
                _self.setQuality(Math.max.apply(Math, self$1.levelsAll));
            } else if (videos[0] !== undefined) {
                event.target.dataset.width = videos[0].videoWidth;
                event.target.dataset.height = videos[0].videoHeight;
            }
        });
        this.player.on("timeupdate", function (event) {
            var videos = document.getElementsByClassName("vjs-tech");
            if (videos[0] !== undefined && event.target.dataset !== undefined && +event.target.dataset.width !== videos[0].videoWidth && +event.target.dataset.height !== videos[0].videoHeight) {
                // call `handleResolutionChange` one or more times
                // if `event.target` `.videoWidth` or `.videoHeight` changed
                window._qualityButton.unpressButton();
                handleResolutionChange.call(event.target, event);
            }
        });
    };

    hlsQualityPlugin.prototype.createQualityButton = function createQualityButton() {

        var player = this.player;
        var videoJsButtonClass = videojs.getComponent('MenuButton');
        var menu = this.options && this.options.menu ? this.options.menu : "";
        var concreteButtonClass = videojs.extend(videoJsButtonClass, {
            constructor: function constructor() {
                videoJsButtonClass.call(this, player, { title: player.localize('quality'), name: "QualitySelector", controlText_: player.localize('quality') });
            },
            createItems: function createItems() {
                return [];
            }
        });

        window._qualityButton = new concreteButtonClass();
        var placementIndex = player.controlBar.children().length - 2;
        if (menu !== "default") {
            var concreteButtonInstance = player.controlBar.addChild(window._qualityButton, { componentClass: 'qualitySelector' }, placementIndex);
            concreteButtonInstance.addClass("vjs-quality-selector");
            concreteButtonInstance.addClass("vjs-icon-hd");
            concreteButtonInstance.removeClass("vjs-hidden");
        }

        if (player.qualityLevels() && player.qualityLevels().levels_ && player.qualityLevels().levels_.length > 0) {
            this.onAddQualityLevel();
        } else {
            this.bindPlayerEvents();
        }
    };

    hlsQualityPlugin.prototype.getQualityMenuItem = function getQualityMenuItem(item) {
        var self = this;
        var player = this.player;
        var videoJsMenuItemClass = videojs.getComponent('MenuItem');
        var concreteMenuItemClass = videojs.extend(videoJsMenuItemClass, {
            constructor: function constructor() {
                videoJsMenuItemClass.call(this, player, {
                    label: item.label,
                    id: item.id,
                    selectable: true,
                    selected: item.selected || false,
                    value: item.value
                });
            },
            handleClick: function handleClick(event) {
                // Reset other menu items selected status.
                for (var i = 0; i < window._qualityButton.items.length; ++i) {
                    window._qualityButton.items[i].selected(false);
                }

                // Set this menu item to selected, and set quality.
                self.setQuality(item.value);
                this.selected(true);
            }
        });
        return new concreteMenuItemClass();
    };

    hlsQualityPlugin.prototype.onAddQualityLevel = function onAddQualityLevel(event) {
        var self = this;
        var player = this.player;
        var qualityList = player.qualityLevels();
        var levels = qualityList.levels_ || [];
        var levelItems = [];
        var has_selected_bit = false;
        var selected_value = false;
        var empQuality = self.getCookie('emp-quality');

        for (var i = 0; i < levels.length; ++i) {
            selected_value = false;
            if (empQuality && levels[i].height == empQuality) {
                selected_value = empQuality;
                has_selected_bit = true;
            } else if (this.options.defaultBitrate && this.options.defaultBitrate !== null && this.options.defaultBitrate !== undefined && this.options.defaultBitrate > 0 && levels[i].height == this.options.defaultBitrate) {
                selected_value = levels[i].height;
                has_selected_bit = true;
            }
            var levelItem = this.getQualityMenuItem.call(this, {
                label: levels[i].height + 'p',
                value: levels[i].height,
                id: "id_" + levels[i].height,
                selected: selected_value
            });
            levelItems.push(levelItem);
            this.levelsAll.push("" + levels[i].height);
        }

        levelItems.push(this.getQualityMenuItem.call(this, {
            label: 'Auto',
            value: 'auto',
            id: "id_" + "auto",
            selected: !has_selected_bit
        }));

        if (window._qualityButton) {
            window._qualityButton.createItems = function () {
                return levelItems;
            };
            window._qualityButton.update();
            player.trigger("qualityitemupadated");
        }
    };

    hlsQualityPlugin.prototype.setQuality = function setQuality(height) {
        this.setCookie('emp-quality', height, 300);
        var qualityList = this.player.qualityLevels();
        for (var i = 0; i < qualityList.length; ++i) {
            var quality = qualityList[i];
            quality.enabled = quality.height == height || height === 'auto';
        }
        try {
            window._qualityButton.unpressButton();
        } catch (e) {}
    };

    hlsQualityPlugin.prototype.setCookie = function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    hlsQualityPlugin.prototype.getCookie = function getCookie(cname) {
        var name$$1 = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name$$1) == 0) {
                return c.substring(name$$1.length, c.length);
            }
        }
        return "";
    };

    return hlsQualityPlugin;
}();

// Register the plugin with video.js.


registerPlugin('hlsQuality', hlsQuality);

// Include the version number.
hlsQuality.VERSION = version;

module.exports = hlsQuality;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_hls_quality/dist/videojs-hls-quality.cjs.js
// module id = 443
// module chunks = 1